import React, { useEffect, useState, useContext } from 'react';
import useCalculateInsurance from '../../hooks/useCalculateInsurance';

import InsuranceOrderHeader from './components/InsuranceOrderHeader';
import TouristsDataList from './components/TouristsDataList';
import ContinueButton from './components/ContinueButton';
import AcceptRules from './components/AcceptRules';
import { Wrapper } from './styles';
import { Company, Offers, Tourist } from '../../types';
import { InsuranceContext } from '../../context/insuranceContext';

const ThirdStep: React.FC<{}> = () => { 
  const [filedsStatus, setFieldsStatus] = useState(false);
  const [agreeWithRules, setAgreeWithRules] = useState(false);

  const { getOffers, availableOffers } = useCalculateInsurance();
  const { 
    insurance, 
    insuranceParameters, 
    setInsuranceParameters, 
    setInsurance 
  } = useContext(InsuranceContext);
  const { beneficiary, details } = insurance || {};  
  const { selectedTourists } = insuranceParameters || {};
  
  useEffect(() => {
    getOffers(insurance);    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details, beneficiary.length]); 
  
  const btnDisabledStatus = filedsStatus && agreeWithRules;
  
  useEffect(() => {
    const fieldResults = selectedTourists.map((tourist:Tourist) => tourist.fieldsCompleted);    
    const fieldStatus = fieldResults.every((field:boolean) => field === true);   
    setFieldsStatus(fieldStatus);   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...selectedTourists]);

  useEffect(() => {   
    window.scrollTo(0, 0);
  }, []);

  const companies = availableOffers?.offersResponce?.companies || [];  

  const selectedCompany = companies?.filter(
    (company: Company) => company.name === insuranceParameters.selectedInsurance.name
  );

  const selectedOffer = selectedCompany[0]?.offers?.filter(
    (offer: Offers) => offer.sum === insuranceParameters.selectedInsurance.sum
  );     
   
  return (
    <Wrapper>
      <InsuranceOrderHeader
        parameters={insuranceParameters}
        setInsuranceParameters={setInsuranceParameters}
        selectedOffer={selectedOffer}
      />
      <TouristsDataList
        insurance={insurance}
        parameters={insuranceParameters}   
        setInsurance={setInsurance}       
        setInsuranceParameters={setInsuranceParameters}
      />
      <AcceptRules 
        agreeRules={agreeWithRules}
        setAgreeRules={setAgreeWithRules}
      />
      <ContinueButton
        parameters={insuranceParameters}
        disabledButton={!btnDisabledStatus}
        setInsuranceParameters={setInsuranceParameters}
        selectedOffer={selectedOffer}
      />
    </Wrapper>
  );
};

export default ThirdStep;
